import React from 'react';
import { formatDuration } from '../date-utils';
import { useSelector } from '../hook-utils';
import { getNow } from '../store/reducers/now';

interface Props {
  ts: number
  noSeconds?: boolean
  reverse?: boolean
}

export default function Timer({ ts, noSeconds, reverse }: Props) {
  const now = useSelector(getNow)
  const elapsed = reverse ? ts - now : now - ts
  return <>{formatDuration(elapsed / 1000, !noSeconds)}</>
}
